import axios from "axios";
import { API } from "../../const";
import { normParam} from "../../tools";
const M_API = API;

const store = {
  namespaced: true,
  state: {
    angkatan: null
  },
  getters: {
    angkatan(state) {
      return state.angkatan;
    }
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/m_angkatan${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    form(_, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/m_angkatan/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/m_angkatan`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${M_API}/instansi/${item.instansi_id}/m_angkatan/${item.id}`).then(res => {
        return res;
      });
    },
  }
};

export default store;
